const pluralize = require('pluralize');

export default {
  anonymize(name) {
    const nameComponents = name.split(' ');

    if (nameComponents.length) {
      const firstName = nameComponents[0];
      const lastName = nameComponents.slice(-1)[0];

      const capitalizedFirstName = `${firstName.charAt(0).toUpperCase()}${firstName.slice(1)}`;
      const lastInitial = `${lastName.charAt(0).toUpperCase()}.`;

      return `${capitalizedFirstName} ${lastInitial}`;
    }

    if (name.length) {
      return `${name.charAt(0).toUpperCase()} ${name.slice(1)}`;
    }

    return '';
  },
  capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  },
  fullName(firstName, lastName) {
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    } else if (firstName) {
      return firstName;
    } else if (lastName) {
      return lastName;
    }

    return "";
  },
  // Converts a word to kebab case, removing special chars
  // e.g "I'm Finished" becomes "im-finished"
  kebabCase(word) {
    return word.toLowerCase().trim().replace(/[^\w\s]/gi, "").replace(" ", "-")
  },
  pluralize(noun, count) {
    return pluralize(noun, count);
  },
  prefix(gender) {
    const genderPrefixes = {
      male: "Mr.",
      female: "Ms."
    };

    if (typeof genderPrefixes[gender] !== "undefined") {
      return genderPrefixes[gender];
    }

    return "";
  },
  uppercase(word) {
    return word.toUpperCase();
  },

}
